import React, { createContext, useState, useContext, useEffect } from 'react';
import { translations } from '../translations/translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        // Get language from localStorage or default to 'uz'
        return localStorage.getItem('language') || 'uz';
    });

    useEffect(() => {
        // Save language to localStorage whenever it changes
        localStorage.setItem('language', language);
    }, [language]);

    const switchLanguage = (lang) => {
        if (lang === 'uz' || lang === 'ru') {
            setLanguage(lang);
        }
    };

    // Translation function - supports nested keys like 'header.phone'
    const t = (key) => {
        if (!key || typeof key !== 'string') {
            return key;
        }

        const keys = key.split('.');
        let value = translations[language];

        // Navigate through the nested structure
        for (const k of keys) {
            if (value && typeof value === 'object' && k in value) {
                value = value[k];
            } else {
                return key; // Return key if translation not found
            }
        }

        // Return the value (should be a string at this point)
        return typeof value === 'string' ? value : key;
    };

    const value = {
        language,
        setLanguage,
        switchLanguage,
        t
    };

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within LanguageProvider');
    }
    return context;
};

export default LanguageContext;